import {
  EXTENDED_WARRANTY_2YEAR_SKU,
  EXTENDED_WARRANTY_3YEAR_SKU,
} from '@/app/[locale]/store/_consts';

import WarrantySelection from '../_steps/enums/WarrantySelection';

const getExtendedWarrantyStep = (
  sku: string | null | undefined,
): WarrantySelection => {
  switch (true) {
    case sku === EXTENDED_WARRANTY_3YEAR_SKU:
      return WarrantySelection.ThreeYear;
    case sku === EXTENDED_WARRANTY_2YEAR_SKU:
      return WarrantySelection.TwoYear;
    default:
      return WarrantySelection.OneYear;
  }
};

export default getExtendedWarrantyStep;
